import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useRemoveShopPaymentMethodMutation = createMutationHook(
  PaymentApiClient.removeShopPaymentMethod,
  {
    mutationKey: ['removeShopPaymentMethod'],
  },
)
